import { useQuery } from '@tanstack/react-query';
import { getChatStatus } from '../services/chatService';

export const CHAT_STATUS_KEY = ['chat', 'status'] as const;

/**
 * One GET /api/chat/status per page load. It shares the chat rate limit with turns (6/min, 60/h per IP),
 * so it is cached for the whole session and never retried or refetched on focus/reconnect.
 * `data === null` means no chat entry point at all.
 */
export const useChatStatus = () =>
  useQuery({
    queryKey: CHAT_STATUS_KEY,
    queryFn: getChatStatus,
    staleTime: Infinity,
    gcTime: Infinity,
    retry: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });
